module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10058.ce05af00.jpg";